import React from 'react';
import {
	Alert,
	Button,
	Form,
	FormField,
	FormNote,
	FormRow,
	Glyph,
	Input,
	InputGroup,
	Loader,
	Select
} from 'kepler';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { i18n } from 'react-i18n';
import SearchResult from '../components/searchResult';

const STATES = require('../data/states');
var notLoading = true;

export default class PartnerApp extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			inputCountrySelect: '',
			inputStateSelect: '',
			searchResult:false,
			searchResultValues:'',
			lstModFromMinDate:'',
			lstModFromMaxDate: moment(),
			lstModToMinDate:'',
			lstModToMaxDate:moment(),
			lstModstartFromDate: '',
			lstModstartToDate:'',
			rgnFromMinDate:'',
			rgnFromMaxDate: moment(),
			rgnToMinDate:'',
			rgnToMaxDate:moment(),
			rgnstartFromDate: '',
			rgnstartToDate:'',
			loader:false,
			pageNo:'',
			nonprofitId:'',
			nonprofitName:''
		};
		this.handleLstModFromDate = this.handleLstModFromDate.bind(this);
		this.handleLstModToDate = this.handleLstModToDate.bind(this);
		this.handleRgnFromDate = this.handleRgnFromDate.bind(this);
		this.handleRgnToDate = this.handleRgnToDate.bind(this);
		this.startaNewSearch = this.startaNewSearch.bind(this);
		this.modifySearch = this.modifySearch.bind(this);
		this.formSubmit = this.formSubmit.bind(this);
		this.updateStateSelect = this.updateStateSelect.bind(this);
		this.updateCountrySelect = this.updateCountrySelect.bind(this);
		this.trimNonProfitID = this.trimNonProfitID.bind(this);
	}

	handleLstModFromDate(date) {
		this.setState({
			lstModstartFromDate: date
		});
		this.setState({
			lstModToMinDate: date
		});
	}

	handleLstModToDate(date) {
		this.setState({
			lstModstartToDate: date
		});
	}

	handleRgnFromDate(date) {
		this.setState({
			rgnstartFromDate: date
		});
		this.setState({
			rgnToMinDate: date
		});
	}

	handleRgnToDate(date) {
		this.setState({
			rgnstartToDate: date
		});
	}

	startaNewSearch(){
		const self = this;
		self.setState({
			inputCountrySelect: '',
			inputStateSelect: '',
			searchResult:false,
			searchResultValues:'',
			lstModFromMinDate:'',
			lstModFromMaxDate: moment(),
			lstModToMinDate:'',
			lstModToMaxDate:moment(),
			lstModstartFromDate: '',
			lstModstartToDate:'',
			rgnFromMinDate:'',
			rgnFromMaxDate: moment(),
			rgnToMinDate:'',
			rgnToMaxDate:moment(),
			rgnstartFromDate: '',
			rgnstartToDate:'',
			loader:false,
			pageNo:'',
			nonprofitId:'',
			nonprofitName:''
	  	});
	  	notLoading = true;
	}

	modifySearch(){
		const self = this;
		self.setState({
			searchResult: false,
			searchResultValues:'',
	  	});
	  	notLoading = true;
	}

	componentDidUpdate() {
		const self = this;
		if (self.state.inputCountrySelect !== 'US') {
			$("#stateFormField").hide();
			$('#countryFormField').attr('style', 'width:100%');
		}
	}

	componentDidMount() {
      const self = this;
      $("#stateFormField").hide();
      $('#countryFormField').attr('style', 'width:100%');
		$(window).on('scroll', function() {
			if ($('#searchResult').is(":visible")) {
		      	let $elem = $('#searchResult'),
		        $window = $(window),
		        docViewTop = $window.scrollTop(),
		        docViewBottom = docViewTop + $window.height(),
		        elemTop = $elem.offset().top,
		        elemBottom = elemTop + $elem.height();
				if ((elemBottom < docViewBottom) && notLoading) {
					$("#loadmorespinner").show();
					self.startLoadingMoreSearchResults();
					notLoading = false;
				}
		    }
		});

		$('input').keypress(function (e) {
		  if (e.which == 13) {
		    self.formSubmit();
		    return false;
		  }
		});

		$.fn.serializeObject = function() {
			const o = {};
			const a = this.serializeArray();
			$.each(a, function() {
				if (o[this.name]) {
					if (!o[this.name].push) {
						o[this.name] = [o[this.name]];
					}
					o[this.name].push(this.value || '');
				} else {
					o[this.name] = this.value || '';
				}
			});
			return o;
		};
   	}

   	startLoadingMoreSearchResults() {
   		const self = this;
   		let csrf = $('body').attr('data-csrf');
	    notLoading = false;
	    let scrollID = $('#scrollID').val();

	    const params = {};
		params.charity_type= 'PPGF_GUIDESTAR';
        params.scroll = true;

		let data = {
				params: params,
				_csrf: csrf
			};

	    let nextPageNo = $('[name=nextPageNo]').val();
	    $.post('/givingfund/partner/resultsmore', {
	      _csrf: csrf,
	      params: params,
	      nextPageNo: nextPageNo,
	      scrollID: scrollID
	    }, function(result) {
	      notLoading = true;
	      self.setState({
				searchResult: true,
				searchResultValues:result.searchResults
		  });
	      $("#loadmorespinner").hide();
	      if (result.searchResults.results.length === 0) {
	        $('[name=moreResults]').val('false');
	        $("#loadmorespinner").hide();
	        notLoading = false;
	      } else {
	        $('[name=nextPageNo]').val(parseInt(result.pageNo) + 1);

	      }
	    })
	}

	validateDate(paramsTosend) {
			if (paramsTosend.last_modified_From_date) {
				let fromDate = this.formateDate(paramsTosend.last_modified_From_date);

				if (paramsTosend.last_modified_To_date) {
					var toDate = this.formateDate(paramsTosend.last_modified_To_date);
				} else {
					let todayDate = this.GetTodayDate();
					var toDate = this.formateDate(todayDate);
				}

				paramsTosend.last_modified_date = "[" + fromDate + "," + toDate + "]";
			}

			if (paramsTosend.rgn_modified_From_date) {
				let regnFromDate = this.formateDate(paramsTosend.rgn_modified_From_date);

				if (paramsTosend.last_modified_To_date) {
					var regnToDate = this.formateDate(paramsTosend.last_modified_To_date);
				} else {
					let todayDate = this.GetTodayDate();
					var regnToDate = this.formateDate(todayDate);
				}

				paramsTosend.registration_date = "[" + regnFromDate + "," + regnToDate + "]";
			}

			delete paramsTosend.last_modified_From_date;
			delete paramsTosend.last_modified_To_date;
			delete paramsTosend.rgn_modified_From_date;
			delete paramsTosend.rgn_modified_To_date;
	}

	GetTodayDate() {
		let tdate = new Date();
		let dd = tdate.getDate() + '';
		dd = (dd.length == 1) ? ('0' + dd) : dd;
		let MM = tdate.getMonth() + 1 + '';
		MM = (MM.length == 1) ? ('0' + MM) : MM;
		let yyyy = tdate.getFullYear();
		let todayDate = MM + "/" + dd + "/" + yyyy;

		return todayDate;
	}

	updateStateSelect(option) {
		this.setState({
			inputStateSelect: option
		});
	}

	updateCountrySelect(option) {
		const self =  this;
		if (option !== 'US') {
			$("#stateFormField").hide();
			$('#countryFormField').attr('style', 'width:100%');
			self.setState({
				inputCountrySelect: option,
				inputStateSelect: ''
			});
		} else {
			self.setState({
				inputCountrySelect: option
			});
			$("#stateFormField").show();
			$('#countryFormField').attr('style', '');
		}
	}

	formatSearchParams() {
		const data = {},
			state = this.state.inputStateSelect,
			country_code = this.state.inputCountrySelect;
			if (state !== '') data.state = state;
			if (country_code !== '') data.country_code = country_code;
		return data;
	}

	formateDate(date) {
		// date - MM/DD/YYYY
		const _date = date.split("/");
		let formatedDate = _date[2] + "-" + _date[0] + "-" + _date[1];
		return formatedDate;
	}

	trimNonProfitID(val){
	    $('#nonprofit_id').val($('#nonprofit_id').val().replace(/\s/g, ""));
		this.setState({
			nonprofitId: $('#nonprofit_id').val()
		})
	}

	formSubmit() {
		let csrf = $('body').attr('data-csrf');
		const self = this;
		self.setState({
				loader: true
		});

		let mydata = $("form").serializeObject();

		const paramsTosend = {};

		paramsTosend.charity_type= 'PPGF_GUIDESTAR';
		paramsTosend.page_size = 15;
        paramsTosend.page = 1;
        paramsTosend.total_required = true;
        paramsTosend.scroll = true;

		for(let key in mydata){
			if (mydata[key] !== ''){
				paramsTosend[key] = mydata[key];
			}
		}

		let additionalData = self.formatSearchParams();
		self.validateDate(paramsTosend);

		$.extend( true, paramsTosend, additionalData );

		let data = {
			params: paramsTosend,
			_csrf: csrf
		};
		this.ajaxForload_results(data);
	}

	ajaxForload_results(data){
		const self = this;
		$.post('/givingfund/partner', data, function(result,status) {
			if(result.searchResults.total_items == 0){
				self.setState({
					searchResult: false,
					loader:false
				});
				$(window).scrollTop(0);
				$("#searchForm #noResultsError").show("slow").delay(5000).fadeOut("slow");
			} else {
				$("#searchForm #noResultsError").hide();
				$("#searchForm #serverdownError").hide();
				self.setState({
					searchResult: true,
					searchResultValues:result.searchResults,
					loader:false,
					pageNo:result.pageNo

				});
			}
		}).fail(function() {
			self.setState({
				searchResult: false,
				loader:false
			});
			$(window).scrollTop(0);
			$("#searchForm #serverdownError").show("slow").delay(5000).fadeOut("slow");
		})
	}

	render() {

		let stateOptions = STATES.map(function(state) {
			return {
				label: state.abbreviation,
				value: state.abbreviation
			};
		});

		let searchFlag= this.state.searchResult;

	return (
		<div className="container">
			<div id="partnerWrapper" className="row">
				<Loader show={this.state.loader} priority={10} type="fixed" size="lg" opacity={0.5}></Loader>
				{searchFlag ? <SearchResult searchResult={this.state.searchResultValues} pageNo={this.state.pageNo} startaNewSearch={this.startaNewSearch} modifySearch={this.modifySearch}/> : <div id="searchForm">
				<Form type="inline">
					<h1>Find a nonprofit</h1>
					<Alert type="error" className="errors" id="serverdownError"><strong>Error: </strong>Something went wrong, please try after some time.</Alert>
					<Alert type="error" className="errors" id="noResultsError"><strong>Error: </strong> We're not able to get any results, please try with different filters.</Alert>
					<FormField label="Name of nonprofit" htmlFor="nonprofit-name">
						<Input type="text" placeholder="Name of nonprofit" name="name" label="Name of nonprofit" size="sm" value={this.state.nonprofitName} onChange={value => this.setState({ nonprofitName: value })}/>
					</FormField>
					<FormRow>
						<FormField width="one-half" label="Nonprofit ID" htmlFor="non-profitid">
							<Input id="nonprofit_id" type="text" placeholder="Nonprofit ID" name="nonprofit_id" label="Nonprofit ID" size="sm" value={this.state.nonprofitId} onChange={this.trimNonProfitID}/>
						</FormField>
						<FormField width="one-half" label="Tax ID number" htmlFor="ein">
							<Input type="text" placeholder="Tax ID number" name="ein" label="Tax ID number" size="sm" value={this.state.EIN} onChange={value => this.setState({ EIN: value })}/>
						</FormField>
					</FormRow>
					<FormRow>
						<FormField width="one-half" id="countryFormField">
							<Select name="country" value={this.state.inputCountrySelect} options={[{value: "AU", label: "AU"},{value: "CA", label: "CA"},{value: "GB", label: "UK"},{value: "US", label: "US"}]} onChange={this.updateCountrySelect} label="Country" size="sm" placeholder=""/>
						</FormField>
						<FormField width="one-half" id="stateFormField">
							<Select name="state" value={this.state.inputStateSelect} options={stateOptions} onChange={this.updateStateSelect} label="State" size="sm" placeholder=""/>
						</FormField>
					</FormRow>
					<FormNote className="searchDateLabel">Last Modified Date</FormNote>
					<FormRow>
						<FormField width="two-fifths" className="datePickFormField">
							<DatePicker minDate = {this.state.lstModFromMinDate} maxDate = {this.state.lstModFromMaxDate} selected={this.state.lstModstartFromDate} onChange={this.handleLstModFromDate} placeholderText = "MM/DD/YYYY" className = "Input" name="last_modified_From_date"/>
							<Glyph icon="icon-calendar" />
							<FormNote className="dateRangeNote">Enter a single date or a date range</FormNote>
						</FormField>
						<FormField width="one-fifth">
							<FormNote className="searchToLabel">TO</FormNote>
						</FormField>
						<FormField width="two-fifths" className="datePickFormField">
							<DatePicker minDate = {this.state.lstModToMinDate} maxDate = {this.state.lstModToMaxDate} selected={this.state.lstModstartToDate} onChange={this.handleLstModToDate} placeholderText = "MM/DD/YYYY" className = "Input" name="last_modified_To_date"/>
							<Glyph icon="icon-calendar" />
						</FormField>
					</FormRow>
					<FormNote className="searchDateLabel">Registration Date</FormNote>
					<FormRow>
						<FormField width="two-fifths" className="datePickFormField">
							<DatePicker minDate = {this.state.rgnFromMinDate} maxDate = {this.state.rgnFromMaxDate} selected={this.state.rgnstartFromDate} onChange={this.handleRgnFromDate} placeholderText = "MM/DD/YYYY" className = "Input" name="rgn_modified_From_date"/>
							<Glyph icon="icon-calendar" />
							<FormNote className="dateRangeNote">Enter a single date or a date range</FormNote>
						</FormField>
						<FormField width="one-fifth">
							<FormNote className="searchToLabel">TO</FormNote>
						</FormField>
						<FormField width="two-fifths" className="datePickFormField">
							<DatePicker minDate = {this.state.rgnToMinDate} maxDate = {this.state.rgnToMaxDate} selected={this.state.rgnstartToDate} onChange={this.handleRgnToDate} placeholderText = "MM/DD/YYYY" className = "Input" name="rgn_modified_To_date"/>
							<Glyph icon="icon-calendar" />
						</FormField>
					</FormRow>
					<FormField>
						<Button onClick={this.formSubmit} id="searchBtn">Search</Button>
					</FormField>
				</Form>
			</div>}
		</div>
	</div>
	);

	}
}



// WEBPACK FOOTER //
// ./partner/components/partnerContainer.js